export const businessBenefits = [
  {
    title: 'Appointments bookings',
    description:
      'Stay in control of your calendar, organise therapy sessions, and rebook or cancel appointments from our hydrotherapy clinic scheduling tool.',
  },
  {
    title: 'Client communications',
    description: 'Minimise no-shows and save time with automated reminders and client updates.',
  },
  {
    title: 'Services and locations for your hydrotherapy business',
    description: 'Manage your catalogue of pet rehab sessions online in one intuitive platform.',
  },
  {
    title: 'Staff, shifts and schedule management',
    description:
      'Add unlimited team members then easily schedule shifts, time off and services without the admin legwork.',
  },
];
